import * as React from "react";
import { cn } from "@/lib/utils";
interface InputProps extends React.ComponentProps<"input"> {
  label?: string;
  error?: string;
  success?: boolean;
}
const Input = React.forwardRef<HTMLInputElement, InputProps>(({
  className,
  type,
  label,
  error,
  success,
  onFocus,
  onBlur,
  onChange,
  ...props
}, ref) => {
  const [isFocused, setIsFocused] = React.useState(false);
  const [hasValue, setHasValue] = React.useState(!!props.value || !!props.defaultValue);
  
  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(true);
    onFocus?.(e);
  };
  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(false);
    setHasValue(!!e.target.value);
    onBlur?.(e);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setHasValue(!!e.target.value);
    onChange?.(e);
  };
  
  return <div className="relative group">
        <input 
          ref={ref} 
          type={type} 
          className={cn(
            "flex h-12 w-full rounded-full border border-input bg-background px-4 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan focus-visible:ring-inset disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-300",
            // Lighter text color when filled
            hasValue ? "text-foreground/90" : "text-foreground",
            label ? "pt-5 pb-1" : "py-2", 
            error ? "border-destructive" : "", 
            success ? "border-green-400" : "", 
            className
          )} 
          onFocus={handleFocus} 
          onBlur={handleBlur}
          onChange={handleChange}
          {...props} 
        />
        
        {label && <label className={cn("absolute left-3 transition-all duration-300 pointer-events-none text-foreground/60", isFocused || hasValue || props.value ? "top-1 text-xs text-accent" : "top-3 text-base")}>
            {label}
          </label>}
        
        
        {/* Success check */}
        {success && <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-green-400 animate-scale-in">
            <i className="fas fa-check"></i>
          </div>}
        
        {/* Error message */}
        {error && <p className="mt-1 text-xs text-destructive animate-fade-in">
            {error}
          </p>}
      </div>;
});
Input.displayName = "Input";
export { Input };